const renderParticipationModal = () => {
   const pageBody = document.querySelector('body');
   const participationModal = document.querySelector('#categories-modal');
   const modalTitle = participationModal?.querySelector('.modal__title');
   const participateList = participationModal?.querySelector('.categories__rules-list--participate');
   const documentsList = participationModal?.querySelector('.categories__rules-list--documents');

   const onCardClick = (evt) => {      
      if (evt.target.closest('.categories__card')) {
         const targetCard = evt.target.closest('.categories__card');
         const participateRules = Array.from(targetCard.querySelectorAll('.categories__card-rules li')).map((rule) => rule.outerHTML);
         const documents = Array.from(targetCard.querySelectorAll('.categories__card-documents li')).map((document) => document.outerHTML);  
         
         modalTitle.textContent = targetCard.querySelector('.categories__card-info p').textContent;
         participateList.innerHTML = participateRules.join(' ');

         // Если нет документов, скрываем блок
         if (documents.length > 0) {
            documentsList.innerHTML = documents.join(' ');
            documentsList.parentElement.style.display = "block";
         } else {
            documentsList.parentElement.style.display = "none";
         }
      }
   };

   participationModal && pageBody.addEventListener('click', onCardClick);
};

export default renderParticipationModal;
